import { type FC } from "react";
import { Button, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { Filter, useFilter } from "@/partner/shared/components/Filter";
import { DownloadReportButton } from "@/partner/features/reports";
import { ReportTypeType } from "@/types/graphql/partner.generated";
import { buildLinksFilter } from "../model/buildLinksFilter";

interface LinksFilterProps {
  onCreateLink: () => void;
}

export const LinksFilter: FC<LinksFilterProps> = ({ onCreateLink }) => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  return (
    <Filter
      title={t("links.filter.title")}
      action={
        <Stack direction="row" spacing={1} alignItems="center">
          <DownloadReportButton
            type={ReportTypeType.LinksType}
            filter={
              buildLinksFilter(filter) as Record<string, unknown> | undefined
            }
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            disableElevation
            onClick={onCreateLink}
          >
            {t("common.actions.add")}
          </Button>
        </Stack>
      }
      fields={{
        search: true,
      }}
    />
  );
};
